import { render, staticRenderFns } from "./AdminAddBusCompanyModal.vue?vue&type=template&id=fc499ad8&"
import script from "./AdminAddBusCompanyModal.vue?vue&type=script&lang=js&"
export * from "./AdminAddBusCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports